import type { Level } from "@backstory/protocol";

export function LevelBadge({ level }: { level: Level }) {
  const tone = level === "HEALTHY" ? "ok" : level === "CONSTRAINED" ? "info" : level === "DEGRADED" ? "warn" : "danger";
  const label = level.charAt(0) + level.slice(1).toLowerCase();
  return (
    <span className={`badge ${tone}`} title={`Worst recorder level: ${label}`}>
      {label}
    </span>
  );
}

export function ErrorsBadge({ count }: { count: number }) {
  if (!count) return <span className="badge neutral">0</span>;
  return (
    <span className="badge danger" title={`${count} errors`}>
      ⚠ {count}
    </span>
  );
}

export function GapsIcon({ hasGaps }: { hasGaps: boolean }) {
  if (!hasGaps) return <span className="muted">—</span>;
  return (
    <span className="badge warn" title="Recording has gaps (data intentionally shed)">
      ▨ gaps
    </span>
  );
}

export function DeviceBadge({ device }: { device?: string }) {
  const icon = device === "mobile" ? "📱" : device === "tablet" ? "▭" : device === "desktop" ? "🖥" : "•";
  return <span aria-label={device ?? "unknown device"}>{icon}</span>;
}
